// extracted by mini-css-extract-plugin
export var Copyright = "styles-module--Copyright--QR6Gf";